import { ioValidacionQr } from '@/febos/servicios/api/herramientas.api';

export default {
  async checkQrApprovals({ commit }, payload) {
    try {
      const response = await ioValidacionQr(payload);
      if (response.data.codigo !== 10) throw response.data;
      commit('SET_APPROVALS_DETAILS', response.data);
      return response.data;
    } catch (error) {
      console.log('ERROR', error);
      return error;
    }
  }
};
